import React, { useEffect, useState } from "react"
import styles from "./returnList.module.scss"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation } from "next-i18next"
import ReturnListItem from "../ReturnListItem/ReturnListItem"
import Button from "@/components/core/Button/Button"

const ReturnItemList = props => {
  const [errorMsg, setErrorMsg] = useState("")
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  const handleNext = () => {
    if(props.returnedItems?.returnData === ""){
      setErrorMsg(t("kf.returns.label.reasonReturnError"))
    }else{
      setErrorMsg("")
      props.handleUpdate(true)
      props.onNext()
    }
  }

  const getQuantity =
  props?.data?.shipDetail[0]?.item?.filter(list => list.sku === props.skuId)[0]?.shippedQty -
    props.orderData?.returns?.order
      ?.filter(item => item.order_no === props.data?.extOrderNo)
      ?.reduce(
        (result, list) => Number(result) + Number(list.items[0]?.return_qty),
        0
      )

  return (
    <div className={styles.returnItem}>
      <div className="returnItem__head">
        <div className="returnItem__section">
          <ReturnListItem
            isReturns={true}
            curstep={props.curStep}
            data={props.data?.shipDetail[0] ?? {}}
            brandName={props.brandName}
            currencySign={props.currencySign}
            status={props.status}
            skuId={props.skuId}
            quantityVal={getQuantity ?? ""}
            getItems={props.getItems}
            reasonList={props.reasonList}
            handleReturnData={props.handleReturnData}
            orderData={props.orderData}
            totalQuantity={props?.data?.shipDetail[0]?.item?.filter(list => list.sku === props.skuId)[0]?.shippedQty ?? ""}
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
          />
          {props.status !== "complete" ? (
            <div className="returnitem__nextbutton">
              <Button
                role="button"
                customClass="returnitem__next"
                label={staticText.returnNext}
                onClick={handleNext}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
export default ReturnItemList
